import React from "react";
import { Button, Icon } from "antd";

const DownloadingStep = ({ allowCancel, onCancel, type }) => (
  <div className="downloading-content">
    <h4>
      {type === "report" ? "Descargando informe..." : "Descargando archivo..."}
    </h4>
    <Icon type="sync" spin className="loading-icon" />

    <div className="footer-buttons">
      {allowCancel && (
        <Button type="default" className="cancel-btn" onClick={onCancel}>
          Cancelar
        </Button>
      )}
    </div>
  </div>
);

export default DownloadingStep;
